import LegalPage from "@/components/LegalPage";

const SECTIONS = [
    {
        h: "Information We Collect",
        p: [
            "When you contact Vivek Coaching Centre through our website's enquiry form, by phone, by email or on WhatsApp, we collect the details you choose to share with us — typically your name, phone number, email address and the nature of your enquiry.",
            "We do not collect any payment information through this website, and we do not ask for sensitive personal data (such as caste, religion, or biometric details) through the enquiry form.",
        ],
    },
    {
        h: "How We Use Your Information",
        p: [
            "Your details are used solely to respond to your enquiry, advise you on suitable batches or courses, and coordinate admissions-related communication between our faculty and your family.",
            "We may use your phone number or email to contact you about your enquiry or, where you have opted in, to share important updates about batches, tests and schedules.",
        ],
    },
    {
        h: "Children's Information",
        p: [
            "As an educational coaching institute, many of our students are minors. Enquiries about minor students are handled through their parents or legal guardians, and any information shared about a minor is used only for academic and administrative purposes.",
        ],
    },
    {
        h: "Cookies & Analytics",
        p: [
            "This website may use standard analytics tools to understand general usage patterns — such as which pages are visited — in order to improve the website experience. These tools do not identify individual students or families.",
        ],
    },
    {
        h: "Data Sharing",
        p: [
            "We do not sell, rent or trade your personal information. Your details are shared only with the faculty or staff member best placed to answer your enquiry, or where disclosure is required by applicable law.",
        ],
    },
    {
        h: "Data Security & Retention",
        p: [
            "Enquiry details are stored securely and accessed only by authorised staff. We retain enquiry records only for as long as needed to respond to your enquiry and manage any resulting admission, after which they are disposed of responsibly.",
        ],
    },
    {
        h: "Your Choices",
        p: [
            "You may ask us at any time to confirm what details of yours we hold, correct them, or delete them. You may also opt out of non-essential communication by telling us over call or email.",
        ],
    },
    {
        h: "Contact for Privacy Matters",
        p: [
            "For any question, correction request or deletion request relating to your personal information, reach us at zyne6431@gmail.com or call +91 6207984279.",
        ],
    },
];

const Privacy = () => (
    <LegalPage
        eyebrow="Privacy Policy"
        testid="privacy-page"
        titleLines={[
            "Your data,",
            <span key="a" className="f-serif normal-case font-medium text-[#FF5500]">
                respected.
            </span>,
        ]}
        intro="Vivek Coaching Centre respects the privacy of every student, parent and visitor. This policy explains what information we collect through this website, how we use it, and the choices you have."
        sections={SECTIONS}
    />
);

export default Privacy;
